'use client';

import { Link } from 'solito/link';
import { Text, XStack, YStack } from '@ninjacart/nc-nk-ui';
import { AllQnaList } from './AllQnaList';
import type {
    IActionDataModel,
    IAdaptiveActionCard,
    IQuestionAnswer,
} from '@ninjacart/nc-nk-core';
import { ArrowLeft, ArrowRight } from '@tamagui/lucide-icons';

type QnaCard = IAdaptiveActionCard<IActionDataModel<IQuestionAnswer>>;

type AllQnaViewProps = {
    questions: QnaCard[];
    hasNext: boolean;
    currentPage: number;
};

export function AllQnaView({ questions, hasNext, currentPage }: AllQnaViewProps) {
    return (
        <YStack
            paddingVertical={32}
            paddingHorizontal={20}
            maxWidth={900}
            marginHorizontal={0}
            style={{ minHeight: '100vh' }}
            position="relative"
            alignItems="flex-start"
        >
            <YStack marginBottom={20}>
                <Text fontSize={30} fontWeight="700" marginBottom={12} color="$usertextColor">
                    Q&A Index
                </Text>
            </YStack>

            <AllQnaList questions={questions} />

            <XStack
                marginTop={10}
                paddingTop={14}
                alignItems="center"
                justifyContent="flex-start"
                gap={16}
            >
                {currentPage > 1 && (
                    <Link
                        href={currentPage - 1 === 1 ? '/all-qna' : `/all-qna?page=${currentPage - 1}`}
                        aria-label={`Go to page ${currentPage - 1}`}
                        prefetch={false}
                    >
                        <XStack
                            alignItems="center"
                            justifyContent="center"
                            cursor="pointer"
                            gap={4}
                        >
                            <ArrowLeft size={20} color="$primary" />
                            <Text fontWeight="600" color="$primary" fontSize={16}>
                                Prev
                            </Text>
                        </XStack>
                    </Link>
                )}

                {hasNext && (
                    <Link
                        href={`/all-qna?page=${currentPage + 1}`}
                        aria-label={`Go to page ${currentPage + 1}`}
                        prefetch={false}
                    >
                        <XStack
                            alignItems="center"
                            justifyContent="center"
                            cursor="pointer"
                            gap={4}
                        >
                            <Text fontWeight="600" color="$primary" fontSize={16}>
                                Next
                            </Text>
                            <ArrowRight size={20} color="$primary" />
                        </XStack>
                    </Link>
                )}
            </XStack>
        </YStack>
    );
}
